import { StyledParagraph } from '@components/Text';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { HeadingColor, ImgWH, ImgWidth100, LabelColor, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import os from '@src/lang/ko/main/os/os';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card, CardDesc, CardLayout, CardOverlay, ToggleBtn } from '../../Os.style';
import { DivAllCenter, DivFlexColumn, DivFlexRow } from '@pages/CommonStyle/commonDiv.style';
import { HeadingH3, HeadingH3white } from '@components/Text/Heading/Heading.style';
import { Link } from 'react-router-dom';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import simple from '@src/lang/ko/simple';
import i18n from '@pages/i18n';
import { IconShowDescOff, IconShowDescOn } from '@assets/images/main/icon';
import { DownloadButton, DownloadImg, DownloadSectionLayout } from './DownloadSection.style';
import { IconChevRight, IconChevronRight } from '@assets/images/icon';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { StyledGridContainer } from '@components/Grid/Grid.style';

export const SpaceBar = () => <>&nbsp;</>;

const DownloadSection = () => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  return (
    <>
      <DownloadSectionLayout>
        <DivAllCenter>
          <DisplayH2 size={'small'}>
            <Trans i18nKey={`os.downloadSection.title`} />
          </DisplayH2>
          <Spacing pixel="16" />
          <ParagraphColor color="#000" size={'medium'}>
            <Trans i18nKey={`os.downloadSection.desc`} />
          </ParagraphColor>
          <Spacing pixel="32" />
          <DivFlexRow style={{ justifyContent: 'center', gap: '16px' }}>
            <DownloadButton href="https://apps.apple.com/us/app/orbro-service/id1673356996" target="_blank" rel="noopener noreferrer">
              <LabelColor color="#2A70F0" size="large">
                <Trans i18nKey={`os.downloadSection.ios`} />
              </LabelColor>
              <Spacing pixel="4" />
              <ImgWH w="24" h="24" src={IconChevronRight} />
            </DownloadButton>
            <DownloadButton href="https://play.google.com/store/apps/details?id=com.orbro.mobile" target="_blank" rel="noopener noreferrer">
              <LabelColor color="#2A70F0" size="large">
                <Trans i18nKey={`os.downloadSection.aos`} />
              </LabelColor>
              <Spacing pixel="4" />
              <ImgWH w="24" h="24" src={IconChevronRight} />
            </DownloadButton>
          </DivFlexRow>
          <SpacingDTM d="64" t="64" m="48" />
          <StyledGridContainer>
            <DownloadImg src={os.downloadSection.img[layoutType]} />
          </StyledGridContainer>
        </DivAllCenter>
      </DownloadSectionLayout>
    </>
  );
};

export default DownloadSection;
